import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { Container, Row, Col } from 'reactstrap'
import Profile from '../components/profile/profile'

export default function Template({ data, pathContext }) {
  const { markdownRemark: reference } = data;
  const { next, prev } = pathContext;

  return <div>
    <Helmet
      title={`${reference.frontmatter.title}`}
      meta={[
        { name: 'description', content: (reference.frontmatter.excerpt || reference.excerpt) },
        { name: 'keywords', content: reference.frontmatter.technologies },
      ]}
    />

    <article>
      <div className="bg evelope">
        <Container>
          <Row className="align-items-center py-5">
            <Col>
              <h1>{reference.frontmatter.title}</h1>
              <h4 className="text-muted">Referenzen und Use-Cases.</h4>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row>
          <Col className="text-center text-md-left py-4 py-md-6" sm="2">
            <Row>
              <Col xs="3" sm="12">
                <Profile />
              </Col>
              <Col xs="9" sm="12">
                <p className="small mt-4">
                  geschrieben von {reference.frontmatter.author} am <time dateTime={reference.frontmatter.date}>{reference.frontmatter.formattedDate}</time>
                </p>
              </Col>
            </Row>
          </Col>
          <Col className="py-4 py-md-6 reference-text" sm={{ size: 8, offset: 1}}>
            <div className="text-justify" dangerouslySetInnerHTML={{ __html: reference.html }} />

            <div className="d-block small mt-5 py-5 border-top">
              <span className="text-uppercase">{reference.frontmatter.company}</span> &mdash; <span className="text-muted">{reference.frontmatter.technologies.join(', ')}</span>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="navigation">
              {prev &&
                <Link className="link prev" to={prev.frontmatter.path}>
                  {prev.frontmatter.title}
                </Link>}
              {next &&
                <Link className="link next" to={next.frontmatter.path}>
                  {next.frontmatter.title}
                </Link>}
            </div>
          </Col>
        </Row>
      </Container>
    
    </article>
  </div>
}

export const pageQuery = graphql`
  query ReferenceByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      excerpt(pruneLength: 350)
      html
      frontmatter {
        formattedDate: date(formatString: "DD. MMMM YYYY", locale: "de")
        excerpt
        date
        author
        company
        path
        technologies
        title
        featuredImage {
          childImageSharp {
            resolutions(width: 400) {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/reference.js